import { lt } from '@mews/framework';
import { Button, IconName, Size } from '@optimus-web/core';
import { DataTestId } from '@mews-commander/enums';
import { useCreateCancellationPolicyDialogForm } from '../forms/hooks';

interface Props {
    size?: Size;
}

export const CreateCancellationPolicyButton = ({ size }: Props) => {
    const [renderDialog, toggleDialog] = useCreateCancellationPolicyDialogForm();
    return (
        <>
            <Button
                icon={IconName.Add}
                onClick={toggleDialog}
                type="submit"
                data-test-id={DataTestId.CreateCancellationPolicy}
                size={size}
            >
                {lt('CancellationPolicyAddActionButtonText')}
            </Button>
            {renderDialog()}
        </>
    );
};
